import PropTypes from 'prop-types';
import { SelectSearch } from 'mol-ui';
import { useSelector } from 'hooks';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';

const FrequencyPicker = ({
    allowNone = true,
    disabled = false,
    hasError,
    height = '40px',
    margin = '0px 0px 10px 0px',
    nullPlaceholder,
    objectChange = false,
    onChange = () => null,
    value,
    width = '100%'
}) => {

    const { t } = useTranslation();
    const {
        configurations: {
            frequencies
        }
    } = useSelector('config');

    useEffect(() => {
        if (value !== undefined) return;
        const defaultValue = frequencies.find(({ default: isDefault }) => !!isDefault);
        onChange(defaultValue ? defaultValue?.id : 0);
    }, [value]);

    const handleChange = id => {
        if (!objectChange) {
            onChange(id);
        } else {
            onChange(frequencies.find(({ value: frequencyId }) => frequencyId === id));
        }
    };

    const parsedNullPlaceholder = nullPlaceholder ?? t('Única');
    const parsedPlaceholder = nullPlaceholder ?? t('Seleccione una frecuencia');
    
    const options = [...(allowNone ? [{ label: parsedNullPlaceholder, value: 0 }] : []), ...frequencies];

    const selectProps = {
        disabled,
        hasError,
        height,
        margin,
        options,
        value,
        width
    };

    return (
        <SelectSearch
            { ...selectProps }
            fontSize="11px"
            placeholder={ parsedPlaceholder }
            onChange={ handleChange }
        />
    );
};

FrequencyPicker.propTypes = {
    allowNone: PropTypes.bool,
    disabled: PropTypes.bool,
    filter: PropTypes.func,
    hasError: PropTypes.bool,
    height: PropTypes.string,
    margin: PropTypes.string,
    nullPlaceholder: PropTypes.string,
    objectChange: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.number,
    width: PropTypes.string
};

export default FrequencyPicker;
